<script setup lang="ts">
import AppContextChip from './AppContextChip.vue'
import type { ContextItem } from './context-types'

defineProps<{
  items: ContextItem[]
}>()

const emit = defineEmits<{ remove: [id: string] }>()
</script>

<template>
  <TransitionGroup
    v-if="items.length"
    tag="ul"
    class="flex min-w-0 flex-wrap items-center gap-2"
    enter-active-class="transition-[opacity,scale] duration-base ease-soft motion-reduce:transition-none"
    enter-from-class="opacity-0 scale-95"
    leave-active-class="transition-[opacity,scale] duration-fast ease-soft-exit motion-reduce:transition-none"
    leave-to-class="opacity-0 scale-95"
    move-class="transition-transform duration-base ease-soft motion-reduce:transition-none"
  >
    <li
      v-for="item in items"
      :key="item.id"
      :class="['flex', item.kind === 'section' ? 'shrink-0' : 'min-w-0 max-w-full']"
    >
      <AppContextChip :item="item" @remove="emit('remove', $event)" />
    </li>
  </TransitionGroup>
</template>
